module.exports = __webpack_public_path__ + "media/images/ui__textArrowLeftLight--dark-449b41b594cf93ff6c20d66546a2b07f.png";